// SPEC 29 / P37-4 — Termo de Consentimento do Embaixador (LGPD).
// Corpo portado de AmbassadorAgent/ConsentTerm/messages.js, com {companyName}
// resolvido pela marca da instalação (sem hardcode de QuintoAndar).

// Versão vigente do termo — mude sempre que o corpo for materialmente alterado.
export const AMBASSADOR_TERM_VERSION = 'ambassador_beta_v1';
export const AMBASSADOR_TERM_ALIAS =
  'AGENT_AMBASSADOR_APP_TERMS_OF_USE_AND_PRIVACY_POLICY';

const interpolate = (text, companyName) =>
  text.replace(/\{companyName\}/g, companyName);

export const buildConsentTerm = (companyName = 'Imudei') => ({
  title: 'Termo de consentimento para tratamento de dados pessoais.',
  scopeTitle: 'Escopo do consentimento',
  scopeDescription: interpolate(
    'Você autoriza o tratamento de seus dados pessoais para viabilizar a sua participação na iniciativa "Comunidade de Associados {companyName}", que consiste em atuar como beta tester de lançamentos do Grupo {companyName} por um período de 4 (quatro) meses, fornecendo feedbacks e participando de pesquisas e reuniões visando ao desenvolvimento e aprimoramento das ferramentas para corretores.',
    companyName
  ),
  personalDataTitle: 'Dados pessoais tratados',
  personalDataDescription:
    'Nome completo, número de telefone e demais informações eventualmente compartilhadas por você durante sua participação na iniciativa.',
  paragraphs: [
    interpolate(
      'Pelo presente instrumento particular, você autoriza o {companyName}, nos termos da legislação aplicável, a realizar o tratamento de seus dados pessoais para viabilizar a sua participação no Programa "Comunidade de Associados {companyName}".',
      companyName
    ),
    interpolate(
      'O {companyName} atuará em conformidade com as leis e de privacidade e proteção de dados, sobretudo a Lei Federal nº 13.709/2018 – Lei Geral de Proteção de Dados Pessoais ("LGPD"), realizando o tratamento dos dados pessoais do Titular de Dados com a finalidade de viabilizar a Iniciativa descrita no presente Termo.',
      companyName
    ),
    'Você está ciente de que seus dados pessoais poderão ser compartilhados com terceiros e de que tal compartilhamento ocorrerá em observância aos princípios e obrigações trazidos pela LGPD.',
    interpolate(
      'É de sua responsabilidade garantir a veracidade e a atualização dos seus dados pessoais transmitidos ao {companyName} para que seja possível a execução da iniciativa.',
      companyName
    ),
    'É assegurado a você o direito de, a qualquer momento, revogar o consentimento concedido por meio deste Termo. Para solicitar a revogação, basta comunicar o administrador do canal no WhatsApp, vamos respeitar sua decisão sem nenhuma restrição.',
  ],
  privacyParagraphPrefix: interpolate(
    'Para mais informações a respeito do tratamento de dados pessoais realizado pelo {companyName}, consulte nosso ',
    companyName
  ),
  privacyLinkLabel: 'Aviso de Privacidade',
  acceptButton: 'Estou ciente e quero continuar',
  registrationConfirmedTitle: 'Inscrição confirmada',
  registrationConfirmedDescription: interpolate(
    'Sua participação na iniciativa "Comunidade de Associados {companyName}" foi confirmada. Você receberá mais informações por Whatsapp em breve.',
    companyName
  ),
  goToAgentApp: 'Ir para a plataforma do corretor',
  errorTitle: 'Algo deu errado',
  errorDescription:
    'Por favor, tente novamente. Se o problema persistir, entre em contato conosco pelo WhatsApp para assistência.',
  tryAgain: 'Tentar novamente',
});
